require('./aggregatorSidebar.scss')

import React from 'react';
import { OKLink } from 'commonsComponents/OKLink';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import PropTypes from 'prop-types';
import {
    ACCOUNTS,
    CARDS,
    LOANSANDMORTGAGES,
    DEPOSITS,
    INVESTMENTS
} from 'constants/aggregator/products'
import {
    PFM_NEW_FEATURES,
} from 'constants/flagBasedFeatures';
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const language = getLanguage()

class AggregatorSidebar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.renderAmountByBank = this.renderAmountByBank.bind(this)
    }

    getTitle = () => {
        const { productType } = this.props

        return `aggregatorSidebar-total${productType}Balance`
    }

    getIcon = () => {
        const { productType } = this.props

        const mp = {
            [ACCOUNTS]: "cuentas",
            [CARDS]: "tarjetas",
            [LOANSANDMORTGAGES]: "depositos",
            [DEPOSITS]: "casa-hogar",
            [INVESTMENTS]: "fondos-inversion"
        }

        return mp[productType]
    }

    getTotalBalance = () => {
        const { total, isTinkAggregator } = this.props;

            if (!isTinkAggregator){
                return total && total.get && total.get('balance') ? getPlainAmountObject(total.get('balance')) : null;
            } else {
                return total ? total : null;
            }
        };

    getBankBalance = (bank) => {
        const { isTinkAggregator } = this.props;

        let balance;

        if (!isTinkAggregator){
            balance = bank.get('balance') ? getPlainAmountObject(bank.get('balance')) : null;
        } else {
            balance = bank.balance ? bank.balance : null;
        }

        return balance;
    }

    renderAggregationArea() {
        return (
            <div className="aggregator-balance__aggregation">
                Balance
            </div>
        )
    }

    renderAmountByBank(bank) {
    const { isTinkAggregator } = this.props;
    
    const balance = this.getBankBalance(bank);

        return (
            <div className="aggregator-balance__balance-values__value">
                <div className="row">
                    <div className="aggregator-balance__balance-values__value__name col-xs-6">
                        {!isTinkAggregator ? bank.get('name') : bank.name}
                    </div>
                    <div className="aggregator-balance__balance-values__value__amount col-xs-6">
                        {balance ?
                            <OneLineSymbolAmount
                                amountObject={balance}
                                className="aggregator-view__details__amount"
                                language={language}
                                amountObjectFormatted={formatAmountObject(balance, true)}
                            /> : "-"
                        }
                    </div>
                </div>
            </div>
        )

    }

    renderAmount() {
        const { values } = this.props;

        return (
            <div className="aggregator-balance__balance-values">
                {values && values.map(this.renderAmountByBank)}
            </div>
        )
    }


    renderButtonArea(){
        const { flagBasedFeatures } = this.props
        const hasNewPfmView = flagBasedFeatures.get(PFM_NEW_FEATURES);
        const pfmViewPath = hasNewPfmView ? 
            '/myprofile/global/entities/expenses-by-category/' :
            `/myprofile/global/entities/expenses-by-category/all-categories/${formatText('urlGobalPosition-bothAccount')}/${formatText('urlGobalPosition-allAccounts')}`

        return (
            <footer className="aggregator-balance__buttons">
                <OKLink
                    modifier="widget"
                    to={pfmViewPath}
                >
                    <FormattedText value="aggregatorSidebar-showExpenses" />
                </OKLink>
            </footer>
        )
    }

    render() {
        const balance = this.getTotalBalance();

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="aggregator-balance">
                        <header className="aggregator-balance__title">
                            <div>
                                <i className={`aggregator-balance__title__icon icon icon-${this.getIcon()}`}/>
                                <FormattedText value={this.getTitle()} />
                            </div>
                            {
                               
                                balance ?
                                    <React.Fragment>
                                        <OneLineSymbolAmount
                                            amountObject={balance}
                                            className="aggregator-balance__title__amount"
                                            language={language}
                                            amountObjectFormatted={formatAmountObject(balance, true)}
                                    /></React.Fragment> : "-"
                            }
                        </header>
                        {this.renderAmount()}
                        {this.renderButtonArea()}
                    </div>
                </div>
            </div>
        );
    }
}

AggregatorSidebar.propTypes = {
    flagBasedFeatures: PropTypes.object,
    total: PropTypes.object,
    values: PropTypes.objects,
    productType: PropTypes.string,
    isTinkAggregator: PropTypes.bool
}

AggregatorSidebar.defaultProps = {
    flagBasedFeatures: {},
    total: {},
    values: [],
    productType: ''
}

export { AggregatorSidebar }
